import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Eksport listy do CSV',
  type: 'object',
  properties: {
    props: {
      type: 'array',
      items: {
        type: 'string'
      }
    }
  },
  allOf: [validationMessages]
};
